// @ts-nocheck


import { Link } from '../../lib/routerAdapter';
import { navigate } from '../../lib/routerAdapter';
import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';
import qs from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Section } from '../../components/layout';
import Header from '../../components/layout/Header';
import { Table } from '../../components/ui';



import { setFilter } from '../../ducks/persistFilters';


import { shiftApi } from '../../lib/api';
import { formatDateTimeToString, getListInitialState, setQueryParams } from '../../lib/helpers';



import Filter from './Filter';









const filterPath = window.location.pathname;

class ShiftList extends Component {
  state = {
    ...getListInitialState()
  };

  static defaultProps = {
    location: {}
  };

  columns = [
  {
    title: 'Дата',
    dataIndex: 'date',
    sorterKey: 'date',
    sorter: true,
    // Нужно для того, чтобы не отрабатывал onRow
    onCell: () => ({ onClick: (e) => e.stopPropagation() }),
    render: (date, record) =>
    <Link to={`/shifts/${record.id}`}>
          {formatDateTimeToString(date, 'DD MMMM YYYY')}
        </Link>

  },
  {
    dataIndex: 'id',
    title: 'Служба',
    render: (id, record) =>
    record.orgUnits &&
    uniq(record.orgUnits.map((orgUnit) => orgUnit.name)).join(
      ', '
    )
  },
  {
    title: 'Входящие заявки',
    dataIndex: 'ordersCount',
    sorterKey: 'ordersCount',
    sorter: true
  },
  {
    title: 'Назначено ТС',
    sorter: true,
    dataIndex: 'tripsCount',
    sorterKey: 'tripsCount'
  },
  {
    title: 'Выписано ПЛ',
    dataIndex: 'tripsOpenCount',
    sorterKey: 'tripsOpenCount',
    sorter: true
  }];


  handleRowClick = (id) => navigate(`/shifts/${id}`);

  fetchShifts = async (
  page = 1,
  params = {}) =>
  {
    const { filter } = this.props;
    this.setState({ loading: true });
    if (isEmpty(params)) {
      params = { orderBy: 'date', byDescending: true };
    }
    const { data, totalCount } = await shiftApi.fetchShifts({
      ...filter,
      page,
      ...params
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  setPersistFilter = async (values) => {
    await this.props.setFilter({
      path: filterPath,
      values
    });
  };

  cleanFilter = async () => {
    await this.setPersistFilter({});
    await this.fetchShifts();
  };

  applyFilter = async (filter) => {
    await this.setPersistFilter(filter);
    await this.fetchShifts();
  };

  async componentDidMount() {
    const { page, ...filter } = qs.parse(window.location.search);
    if (!isEmpty(filter)) {
      await this.setPersistFilter(filter);
    }
    await this.fetchShifts(page);
  }

  render() {
    const { location, filter } = this.props;
    const { data, pageSize, totalCount, page, loading } = this.state;
    return (
      <>
        <Header left={<h1>Наряды</h1>} />
        <Section>
          <Filter
            filter={filter}
            cleanFilter={this.cleanFilter}
            applyFilter={this.applyFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            rowKey="id"
            fetch={this.fetchShifts}
            defaultOrderBy="date"
            defaultOrderDirection="descend"
            loading={loading}
            columns={this.columns}
            data={data}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }} />

        </Section>
      </>);

  }
}

export default connect(
  (state) => ({
    filter: state.persistFilters[filterPath] || {}
  }),
  {
    setFilter
  }
)(ShiftList);
